import { useState } from "react";
import { Copy, Check, ExternalLink } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "@/components/ui-kit/Button";

export function ShareWelcome() {
  // Build from the live origin so the link is correct in any environment.
  const url = `${window.location.origin}/welcome`;
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      // Fallback for older browsers / insecure contexts.
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  }

  return (
    <div className="flex flex-col gap-5 sm:flex-row sm:items-center" data-testid="share-welcome">
      <div className="min-w-0 flex-1 space-y-3">
        <div className="flex items-center gap-2 rounded-lg border border-border bg-secondary/40 px-3 py-2">
          <span className="truncate text-sm text-foreground" data-testid="share-welcome-url">{url}</span>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="share-welcome-open"
            className="ml-auto shrink-0 text-muted-foreground hover:text-foreground"
            title="Open welcome page"
          >
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
        <Button size="sm" onClick={copy} data-testid="share-welcome-copy">
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {copied ? "Copied" : "Copy link"}
        </Button>
        <p className="text-xs text-muted-foreground">
          Text this link to a referred client, or print the QR code for in-person scanning. The page needs no login.
        </p>
      </div>
      <div className="shrink-0 rounded-xl border border-border bg-white p-3" data-testid="share-welcome-qr">
        <QRCodeSVG value={url} size={132} level="M" includeMargin={false} />
      </div>
    </div>
  );
}
